import React, { useEffect } from 'react'
import { useDropzone } from 'react-dropzone'

const FileDrop = React.forwardRef((props, ref) => {
  const { setFiles, files, name } = props
  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      'image/*': ['.jpeg', '.png']
    },
    maxSize: 5242880,
    multiple: true,
    onDropRejected: (e) => {
      console.error('\n\nError: ', e)
      window.alert('The file(s) were rejected, please ensure total is below 8mb in size')
    },
    onDrop: (acceptedFiles) => {
      const updatedFiles = files.concat(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file)
          })
        )
      )
      let totalSize = updatedFiles.reduce((accumulator, current) => accumulator + current.size, 0)
      if (totalSize > 104857600) {
        window.alert('The file(s) were rejected, please ensure total is below 5mb in size')
        return
      }
      setFiles(updatedFiles)
    }
  })

  const removeFile = (file) => {
    const updatedFiles = files.filter((currentFile) => currentFile !== file)
    setFiles(updatedFiles)
  }

  const thumbs = files.map((file) => (
    <li className='relative' key={file.name}>
      <div className='flex h-16 w-16 flex-col items-center justify-center rounded border p-2 overflow-hidden'>
        <img src={file.preview} className='h-auto w-16 p-1' alt={`preview of ${file.name}`} />
        <div className='sr-only'>{file.name}</div>
      </div>
      <div className='absolute -bottom-5 z-10 w-full text-center'>
        <button type='button' className='border border-red-600 bg-white hover:bg-red-600 mx-auto rounded-full p-1 hover:text-red-100 text-red-600' onClick={() => removeFile(file)}>
          <svg xmlns='http://www.w3.org/2000/svg' className='h-5 w-5' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth={1}
              d='M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16'
            />
          </svg>
          <span className='sr-only'>delete</span>
        </button>
      </div>
    </li>
  ))

  useEffect(
    () => () => {
      // Make sure to revoke the data uris to avoid memory leaks
      files.forEach((file) => URL.revokeObjectURL(file.preview))
    },
    [files]
  )

  return (
    <section>
      <div {...getRootProps({ className: 'dropzone block px-6 pt-5 pb-6 border-2 border-stone-300 border-dashed rounde-sm text-center w-full cursor-pointer space-y-1' })}>
        <input {...getInputProps()} ref={ref} name={name} />
        <svg xmlns='http://www.w3.org/2000/svg' className='mx-auto h-12 w-12 text-stone-400' stroke='currentColor' fill='none' viewBox='0 0 24 24'>
          <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={1} d='M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z' />
        </svg>
        <div>
          <span className='pr-1 hover:underline'>Upload a file</span>
          or drag and drop
        </div>
      </div>
      <aside>
        <ul className='flex flex-wrap gap-2 my-2 pb-3'>{thumbs}</ul>
      </aside>
    </section>
  )
})
export default FileDrop
